import { cn } from "@/lib/currencyFormatter";

interface BlinkingDotProps {
  className?: string;
  count?: number;
}

export function BlinkingDot({ className, count }: BlinkingDotProps) {
  if (count !== undefined) {
    return (
      <span
        className={cn(
          "flex items-center justify-center h-5 min-w-5 rounded-full bg-destructive text-destructive-foreground text-xs font-medium ml-auto",
          className
        )}
      >
        {count}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "h-2.5 w-2.5 rounded-full bg-destructive ml-auto animate-[pulse_1.5s_infinite] motion-safe:animate-bounce",
        className
      )}
    />
  );
}
